module.exports = __webpack_public_path__ + "img/ceo_way_cho_01.22f73116.png";